$component-class: 'call-to-action-type-2';

.#{$component-class} {
  me-row.#{$component-class}__content {
    display: block;
    border: var(--border-size-sm) solid var(--border-color-primary);
  }

  &__intro {
    padding: var(--spacing-xl);

    @include desktop {
      padding: var(--spacing-4xl);
    }

    [slot='heading'] {
      .me-heading {
        margin-bottom: var(--spacing-lg);

        @include desktop {
          margin-bottom: var(--spacing-xl);
        }
      }
    }

    [slot='description'] {
      .me-text {
        margin-bottom: var(--spacing-xl);

        @include text-style('md', 'md');

        @include desktop {
          margin-bottom: var(--spacing-2xl);

          @include text-style('lg', 'md');
        }
      }
    }

    @include below-desktop {
      .me-row {
        display: grid;
        grid-template-columns: 1fr;
        width: fit-content;
        margin: 0 auto;
        gap: var(--spacing-md);

        > me-column {
          max-width: unset;
          padding: 0;
          margin: 0;

          .me-button {
            width: 100%;
          }
        }
      }
    }
  }

  &__media {
    align-self: stretch;

    [slot='media'] {
      .picture,
      .picture img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .picture img {
        object-fit: cover;
      }
    }
  }
}

.me-column--hidden {
  display: none;
}
